import React from 'react';
import './TestEnvironmentBanner.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const TestEnvironmentBanner = () => (
  <div className="test-environment-banner" role="alert" aria-live="polite">
    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" /> <span>Versión de prueba. No utilizar para operaciones reales.</span>
  </div>
);

export default TestEnvironmentBanner;
